import { useEffect, useState } from "react";
import { User } from "lucide-react";
import { API } from "@/lib/api";

// Loads an authenticated image (httpOnly cookie) as a blob URL.
export default function AuthImage({ path, className, alt = "", fallbackName = "" }) {
  const [src, setSrc] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let revoke;
    let active = true;
    setFailed(false);
    setSrc(null);
    if (!path) return;
    (async () => {
      try {
        const res = await fetch(`${API}/files/${path}`, { credentials: "include" });
        if (!res.ok) throw new Error("fail");
        const blob = await res.blob();
        if (!active) return;
        revoke = URL.createObjectURL(blob);
        setSrc(revoke);
      } catch {
        if (active) setFailed(true);
      }
    })();
    return () => {
      active = false;
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);

  if (!path || failed) {
    const initials = fallbackName
      ? fallbackName.trim().split(" ").slice(0, 2).map((w) => w[0]).join("").toUpperCase()
      : null;
    return (
      <div className={`${className} flex items-center justify-center bg-[#F7EEC7] text-[#48020C] font-serif`}>
        {initials || <User className="w-1/2 h-1/2 opacity-60" />}
      </div>
    );
  }
  if (!src) return <div className={`${className} bg-[#ECE7DC] animate-pulse`} />;
  return <img src={src} alt={alt} className={className} />;
}
